import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Partners from '@app/pages/settings/Partners.tsx';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const PartnersPage = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr(`Partners.pageTitle`, `Partners`)}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_SETTINGS_PARTNERS_READ, PermissionTypesEnum.PERMISSION_SETTINGS_PARTNERS_RW]}
    >
      <Partners />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(PartnersPage, {
  onRedirecting: () => <Intro />,
});
